import React, { useState, useEffect, useCallback } from 'react';
import Sidebar from './dashboard/Sidebar';

const MOBILE_BREAKPOINT = 768;

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= MOBILE_BREAKPOINT);
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);

  const handleResize = useCallback(() => {
    const mobile = window.innerWidth < MOBILE_BREAKPOINT;
    setIsMobile(mobile);
    if (!mobile) setSidebarOpen(true);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar isOpen={sidebarOpen} onToggle={setSidebarOpen} />

      <div style={{
        flex: 1,
        marginLeft: isMobile ? 0 : 250,
        transition: 'margin-left 0.3s ease',
        overflow: 'auto',
        backgroundColor: '#f5f6fa',
        minHeight: '100vh',
      }}>
        {/* Topbar móvil con hamburguesa */}
        {isMobile && (
          <div style={{
            position: 'sticky', top: 0, zIndex: 100,
            background: '#111827', padding: '10px 16px',
            display: 'flex', alignItems: 'center', gap: 12,
          }}>
            <button onClick={() => setSidebarOpen(true)} style={{
              background: 'none', border: 'none', color: '#fff',
              fontSize: 24, cursor: 'pointer', padding: 0, lineHeight: 1,
            }}>
              ☰
            </button>
            <img src="/logo-menu-sidebar-ai-leth-blanco.png" alt="Aileth"
              style={{ height: 28 }}
              onError={(e) => { e.target.onerror = null; e.target.src = "/logo-aileth-navar.png"; }}
            />
          </div>
        )}

        <div style={{ padding: isMobile ? '16px' : '20px' }}>
          {children}
        </div>
      </div>
    </div>
  );
}
